import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(
  (theme, { firstStep, incorrectFormatMessage } = {}) => ({
    headerIcon: { marginRight: 8 },
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: firstStep ? 530 : 815,
      minHeight: firstStep ? 'initial' : 'auto',
      [theme.breakpoints.down('lg')]: {
        width: firstStep ? 530 : 600,
      },
      [theme.breakpoints.down('md')]: {
        height: '100%',
        width: 'initial !important',
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          height: '100%',
          width: 'initial !important',
        }),
        ...(theme.isTablet && {
          width: firstStep ? 530 : 600,
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          width: 'initial !important',
        }),
      },
    },
    stepInfo: {
      fontSize: 18,
      color: theme.palette.darkGrey,
      [theme.breakpoints.down('md')]: {
        fontSize: 16,
      },
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: incorrectFormatMessage && theme.spacing(3.625),
      [theme.breakpoints.down('lg')]: {
        marginBottom: theme.spacing(2),
      },
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
      },
    },
    downloadButton: {
      fontSize: 14,
      padding: '2px 10px',
      [theme.breakpoints.down('md')]: {
        marginTop: theme.spacing(3),
        paddingLeft: 0,
        paddingRight: 0,
        width: 145,
      },
    },
    footerButtons: {
      paddingBottom: 0,
      [theme.breakpoints.down('lg')]: {
        paddingBottom: !firstStep ? '30px' : 'initial',
      },
      [theme.breakpoints.down('md')]: {
        paddingBottom: '16px !important',
      },
    },
  }),
);
